import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import { Login } from "../Pages/Login";
import { useSelector } from "react-redux";
import { Dashboard } from "../Pages/Dashboard";
import { PageNotFound } from "../Pages/PageNotFound";
import { UsersList } from "../Pages/UsersList";
import { ManageKYC } from "../Pages/ManageKYC";
import { AllTransactions } from "../Pages/AllTransactions";
import { WithdrawalRequests } from "../Pages/WithdrawalRequests";
import { DepositRequests } from "../Pages/DepositRequests";
import {AddWhitelables} from "../Pages/Whitelabels/AddWhitelabels"
import { WhitelabelList } from "../Pages/Whitelabels/WhitelabelList";
import { DeletedUsers } from "../Pages/DeletedUsers";
import { Banking } from "../Pages/Banking";
import { AllTrades } from "../Pages/AllTrades";
import CurrencyPairs from "../Pages/Whitelabels/CurrencyPairs";
import { AddUser } from "../Pages/AddUser";
import CorporateKYC from "../Pages/CorporateKYC";
import { EmailWithdrawAction } from "../Pages/EmailWithdrawAction";

export const AllRoutes = () => {
  const isAuthenticated = useSelector((state) => state?.Login?.isAuthenticated);
 
  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <Login />} />
      <Route path="/" element={<ProtectedRoute element={<Dashboard />} />} />
      <Route path="/add-user" element={<ProtectedRoute element={<AddUser />} />} />
      <Route path="/users-list" element={<ProtectedRoute element={<UsersList />} />} />
      <Route path="/manage-kyc" element={<ProtectedRoute element={<ManageKYC />} />} />
      <Route path="/deposits" element={<ProtectedRoute element={<DepositRequests />} />} />
      <Route path="/withdrawals" element={<ProtectedRoute element={<WithdrawalRequests />} />} />
      <Route path="/all-transactions" element={<ProtectedRoute element={<AllTransactions />} />} />
      <Route path="/add-white-labels" element={<ProtectedRoute element={<AddWhitelables />} />} />
      <Route path="/get-white-labels" element={<ProtectedRoute element={<WhitelabelList />} />} />
      <Route path="/deletedusersList" element={<ProtectedRoute element={<DeletedUsers />} />} />
      <Route path="/banking" element={<ProtectedRoute element={<Banking />} />} />
      <Route path="/all-trades" element={<ProtectedRoute element={<AllTrades />} />} />
       <Route path="/currency-pairs" element={<CurrencyPairs />} />
      <Route path="/corporate-kyc" element={<ProtectedRoute element={<CorporateKYC />} />} />
      <Route path="/corporate-users" element={<ProtectedRoute element={<CorporateKYC />} />} />
      <Route path="/emailwithdraw-action" element={<EmailWithdrawAction />} />
      <Route path="/emailwithdraw-accept-reject" element={<EmailWithdrawAction />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};